var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertSummerPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info-circle-solid 1",
    clipPath: "url(#clip0_8068_31967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.5 0.234375C3.48759 0.234375 0.234375 3.48876 0.234375 7.5C0.234375 11.5136 3.48759 14.7656 7.5 14.7656C11.5124 14.7656 14.7656 11.5136 14.7656 7.5C14.7656 3.48876 11.5124 0.234375 7.5 0.234375ZM7.5 3.45703C8.17957 3.45703 8.73047 4.00793 8.73047 4.6875C8.73047 5.36707 8.17957 5.91797 7.5 5.91797C6.82043 5.91797 6.26953 5.36707 6.26953 4.6875C6.26953 4.00793 6.82043 3.45703 7.5 3.45703ZM9.14062 10.8984C9.14062 11.0926 8.98321 11.25 8.78906 11.25H6.21094C6.01679 11.25 5.85938 11.0926 5.85938 10.8984V10.1953C5.85938 10.0012 6.01679 9.84375 6.21094 9.84375H6.5625V7.96875H6.21094C6.01679 7.96875 5.85938 7.81134 5.85938 7.61719V6.91406C5.85938 6.71991 6.01679 6.5625 6.21094 6.5625H8.08594C8.28009 6.5625 8.4375 6.71991 8.4375 6.91406V9.84375H8.78906C8.98321 9.84375 9.14062 10.0012 9.14062 10.1953V10.8984Z",
    fill: "#5C5A9F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8068_31967"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertSummerPrimary);
export default __webpack_public_path__ + "static/media/alert_summer_primary.67df76b05d74bc3e705786704660b8b2.svg";
export { ForwardRef as ReactComponent };